import React, { useEffect, useState } from 'react';
import { createContextHardened } from '../Helper/ContextHelper';

interface ContextProps {
  searchText: string;
  setSearchText: (text: string) => void;
  headerTitle?: string;
  setHeaderTitle: (title?: string) => void;
  isInputDisabled: boolean;
  /** disable all inputs (i.e. during loading) */
  setInputDisabled: (isDisabled: boolean) => void;
  isHidden: boolean;
  /** hide the search bar component */
  setHidden: (isHidden: boolean) => void;
}
const [SearchBarContext, useSearchBar] = createContextHardened<ContextProps>('SearchBar');
export { useSearchBar };

interface Props {
  children: React.ReactNode;
}
/** Makes search bar state available to child compontents */
export default function SearchBarProvider({ children }: Props): React.JSX.Element {
  const [searchText, setSearchText] = useState<string>('');
  const [isInputDisabled, setInputDisabled] = useState<boolean>(false);
  const [isHidden, setHidden] = useState<boolean>(false);

  /** maybe not exactly the right place for this */
  const [headerTitle, setHeaderTitle] = useState<string>();

  useEffect(() => {
    if (isHidden) {
      setSearchText('');
    }
  }, [isHidden]);

  return (
    <SearchBarContext.Provider
      value={{
        searchText,
        setSearchText,
        headerTitle,
        setHeaderTitle,
        isInputDisabled,
        setInputDisabled,
        isHidden,
        setHidden,
      }}
    >
      {children}
    </SearchBarContext.Provider>
  );
}
